module.exports = __webpack_public_path__ + "img/image4.97cbaf8f.png";